var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target, mod));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// lib/main.jsx
var main_exports = {};
__export(main_exports, {
  default: () => main_default
});
module.exports = __toCommonJS(main_exports);
var import_react = __toESM(require("react"));
var import_script = __toESM(require("next/script"));
function SourceFlowForm({
  formId,
  formUrl = null,
  formType = "form",
  ...props
}) {
  const el = (0, import_react.useRef)(null);
  const formPath = `/_sf/api/v1/forms/${formId}`;
  const onAny = (event, ...args) => {
    if (event.startsWith("formio.")) {
      const funcName = `on${event.charAt(7).toUpperCase()}${event.slice(8)}`;
      if (props.hasOwnProperty(funcName) && typeof props[funcName] === "function") {
        props[funcName](...args);
      }
    }
  };
  (0, import_react.useEffect)(function mount() {
    let url;
    if (formUrl) {
      if (formUrl?.startsWith("/")) {
        url = window.location.protocol + "//" + window.location.host + formUrl;
      } else {
        url = formUrl;
      }
    } else {
      url = window.location.protocol + "//" + window.location.host + formPath;
    }
    const fetchData = async () => {
      await loadScript("https://cdn.sourceflow.co.uk/formio/formio.full.min.js").then(async () => {
        await Formio.setProjectUrl(url);
        const frm = new Formio.Form(el.current, url);
        frm.onAny(onAny);
      });
    };
    fetchData();
  });
  return /* @__PURE__ */ import_react.default.createElement("div", {
    ref: el,
    id: `sourceflow-form-${formId}`,
    "data-sourceflow-form": formType,
    "data-sourceflow-form-id": formId,
    "data-sourceflow-url": formUrl
  });
}
function loadScript(src) {
  return new Promise(function(resolve, reject) {
    const s = document.createElement("script");
    let r = false;
    s.type = "text/javascript";
    s.src = src;
    s.async = true;
    s.onerror = function(err) {
      reject(err, s);
    };
    s.onload = s.onreadystatechange = function(script) {
      if (!r && (!this.readyState || this.readyState == "complete")) {
        r = true;
        resolve();
      }
    };
    document.body.appendChild(s);
  });
}
var main_default = SourceFlowForm;
